import { ApiReasonRejectedMobilityFromMap } from "./api-reason-rejected-mobility.from-map";
import { ReasonRejectedMobility } from "../domain/rejected-reason-mobility";

export class ApiReasonRejectedMobilityFromMapper {
  fromMap(map: ApiReasonRejectedMobilityFromMap): ReasonRejectedMobility {
    return new ReasonRejectedMobility({
      reasonRejectTransferItemRequestId: map.reasonRejectTransferItemRequestId,
      detail: map.detail
    });
  }
} 